import Inventory from '../entities/Inventory';
import { url } from './index';

export default async function createTradeIn(inventory: Inventory): Promise<void> {
  const uri = url('create-trade-in');

  const options = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      inventory_id: inventory.id,
    }),
  };

  const response = await fetch(uri, options);

  if (!response.ok) {
    throw new Error('Failed to create trade-in');
  }
}
